import React, { useState } from 'react'
import Headers from '../components/Headers'
import axios from 'axios'; // Import Axios for API requests
import Footer from '../components/Footer'
import Stripe from '../components/Stripe'
import { useLocation } from 'react-router-dom'
import { toast } from 'react-toastify';
const Payment = () => {
    const { state: { price, items, orderId } } = useLocation()
    const [paymentMethod, setPaymentMethod] = useState('stripe')
    const [phoneNumber, setPhoneNumber] = useState('');
    const [loading, setLoading] = useState(false);
    const [mpesaResponse, setMpesaResponse] = useState(null);

    // 🔹 Function to handle M-Pesa payment
    const handleMpesaPayment = async () => {
        if (!phoneNumber.match(/^2547\d{8}$/)) {
            toast.error("Please enter a valid M-Pesa number (format: 2547XXXXXXXX)");
            return;
        }
    
        setLoading(true);
        try {
            const response = await axios.post("https://backend-api-shop-j6ev.onrender.com/api/mpesa/stkpush", {
                phoneNumber,
                amount: price,
                orderId, // ✅ Pass order ID to backend
            });
    
            setMpesaResponse(response.data);
            toast.info("Please check your phone to complete payment");
    
            // Poll for payment status
            let attempts = 0;
            const maxAttempts = 6; // Try for 60 seconds (6 * 10 seconds)
    
            const checkPaymentStatus = async () => {
                try {
                    const orderResponse = await axios.get(
                        `https://backend-api-shop-j6ev.onrender.com/api/mpesa/check-payment/${orderId}`
                    );
    
                    if (orderResponse.data.payment_status === "paid") {
                        toast.success("✅ Payment successful!");
                        return;
                    }
    
                    attempts++;
                    if (attempts < maxAttempts) {
                        setTimeout(checkPaymentStatus, 5000); // Check every 5 seconds
                    } else {
                        toast.error("⚠️ Payment status check timed out. Please check your order status.");
                    }
                } catch (error) {
                    console.error("Error checking payment status:", error);
                }
            };
    
            // Start polling after 10 seconds
            setTimeout(checkPaymentStatus, 10000);
        } catch (error) {
            console.error("M-Pesa payment error:", error);
            toast.error("Payment initiation failed. Please try again.");
        }
        setLoading(false);
    };
    

    return (
        <div>
            <Headers />
            <section className='bg-[#eeeeee]'>
                <div className='w-[85%] lg:w-[90%] md:w-[90%] sm:w-[90%] mx-auto py-16 mt-4'>
                    <div className='flex flex-wrap md:flex-col-reverse'>
                        <div className='w-7/12 md:w-full'>
                            <div className='pr-2 md:pr-0'>
                                <div className='flex flex-wrap'>
                                    <div onClick={() => setPaymentMethod('stripe')} className={`w-[20%] border-r cursor-pointer py-8 px-12 ${paymentMethod === 'stripe' ? 'bg-white' : 'bg-slate-100'}`}>
                                        <div className='flex flex-col gap-[3px] justify-center items-center'>
                                            <img src="https://client-multivendor-ecommerce.vercel.app/images/payment/stripe.png" alt="stripe" />
                                            <span className='text-slate-600'>Stripe</span>
                                        </div>
                                    </div>
                                    <div onClick={() => setPaymentMethod('mpesa')} className={`w-[20%] border-r cursor-pointer py-8 px-12 ${paymentMethod === 'mpesa' ? 'bg-white' : 'bg-slate-100'}`}>
                                        <div className='flex flex-col gap-[3px] justify-center items-center'>
                                            <img src="https://client-multivendor-ecommerce.vercel.app/images/payment/mpesa.webp" alt="stripe" />
                                            <span className='text-slate-600'>Mpesa</span>
                                        </div>
                                    </div>
                                    <div onClick={() => setPaymentMethod('bkash')} className={`w-[20%] border-r cursor-pointer py-8 px-12 ${paymentMethod === 'bkash' ? 'bg-white' : 'bg-slate-100'}`}>
                                        <div className='flex flex-col gap-[3px] justify-center items-center'>
                                            <img src="https://client-multivendor-ecommerce.vercel.app/images/payment/bkash.png" alt="bkash" />
                                            <span className='text-slate-600'>Bkash</span>
                                        </div>
                                    </div>
                                    <div onClick={() => setPaymentMethod('nogot')} className={`w-[20%] border-r cursor-pointer py-8 px-12 ${paymentMethod === 'nogot' ? 'bg-white' : 'bg-slate-100'}`}>
                                        <div className='flex flex-col gap-[3px] justify-center items-center'>
                                            <img src="https://client-multivendor-ecommerce.vercel.app/images/payment/nogot.png" alt="nogot" />
                                            <span className='text-slate-600'>Nogot</span>
                                        </div>
                                    </div>
                                    <div onClick={() => setPaymentMethod('roket')} className={`w-[20%] border-r cursor-pointer py-8 px-12 ${paymentMethod === 'roket' ? 'bg-white' : 'bg-slate-100'}`}>
                                        <div className='flex flex-col gap-[3px] justify-center items-center'>
                                            <img src="https://client-multivendor-ecommerce.vercel.app/images/payment/roket.png" alt="roket" />
                                            <span className='text-slate-600'>Roket</span>
                                        </div>
                                    </div>
                                </div>
                                {
                                    paymentMethod === 'stripe' && <div>
                                        <Stripe orderId={orderId} price={price} />
                                    </div>
                                }
                                {/* M-Pesa Payment */}
                                {paymentMethod === 'mpesa' && (
                                    <div className='w-full px-4 py-8 bg-white shadow-sm'>
                                        <label className='block mb-2 text-slate-600'>Enter M-Pesa Number (e.g., 2547XXXXXXXX):</label>
                                        <input 
                                            type="text" 
                                            className="w-full px-3 py-2 border rounded-md"
                                            value={phoneNumber}
                                            onChange={(e) => setPhoneNumber(e.target.value)}
                                            placeholder="2547XXXXXXXX"
                                        />
                                        <button 
                                            onClick={handleMpesaPayment} 
                                            disabled={loading}
                                            className={`mt-4 px-10 py-[6px] rounded-sm ${loading ? 'bg-gray-400' : 'bg-orange-500 hover:shadow-lg'} text-white`}
                                        >
                                            {loading ? "Processing..." : "Pay Now"}
                                        </button>
                                        {mpesaResponse && (
                                            <p className="mt-3 text-green-500">{mpesaResponse.CustomerMessage}</p>
                                        )}
                                    </div>
                                )}
                                {
                                    paymentMethod === 'bkash' && <div className='w-full px-4 py-8 bg-white shadow-sm'>
                                        <button className='px-10 py-[6px] rounded-sm hover:shadow-wrange-500/20 hover:shadow-lg bg-orange-500 text-white'>Pay Now</button>
                                    </div>
                                }
                                {
                                    paymentMethod === 'nogot' && <div className='w-full px-4 py-8 bg-white shadow-sm'>
                                        <button className='px-10 py-[6px] rounded-sm hover:shadow-wrange-500/20 hover:shadow-lg bg-orange-500 text-white'>Pay Now</button>
                                    </div>
                                }
                                {
                                    paymentMethod === 'roket' && <div className='w-full px-4 py-8 bg-white shadow-sm'>
                                        <button className='px-10 py-[6px] rounded-sm hover:shadow-wrange-500/20 hover:shadow-lg bg-orange-500 text-white'>Pay Now</button>
                                    </div>
                                }
                            </div>
                        </div>
                        <div className='w-5/12 md:w-full'>
                            <div className='pl-2 md:pl-0 md:mb-0'>
                                <div className='bg-white shadow p-5 text-slate-600 flex flex-col gap-3'>
                                    <h2>Order Summary</h2>
                                    <div className='flex justify-between items-center'>
                                        <span>{items} items and shipping fee included</span>
                                        <span>Kes{price}</span>
                                    </div>
                                    <div className='flex justify-between items-center font-semibold'>
                                        <span>Total Amount</span>
                                        <span className='text-lg text-orange-500'>Kes {price}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    )
}

export default Payment